export default __webpack_public_path__ + "static/sprite-b0baea5b196980b892f35781708048db.svg";